export default __webpack_public_path__ + "static/media/Up to date information.9043472a.svg";